import dayjs from "dayjs";
import moment from "moment";
import { GenericApi as _GenericApi } from "@yulintu/freesia-bootstrap";

class GenericApi extends _GenericApi {
    static thenHandlers = []
    static catchHandlers = []
}

export default GenericApi;